<template>
    <!-- begin::Footer -->
    <footer class="m-grid__item m-footer ">
        <div class="m-container m-container--fluid m-container--full-height m-page__container">
            <div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
                <div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
                            <span class="m-footer__copyright">
                                2018 &copy; {{appName}} by
                                <a :href="creatorUrl" class="m-link">
                                    {{creatorName}}
                                </a>
                            </span>
                </div>
                <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
                    <ul class="m-footer__nav m-nav m-nav--inline m--pull-right">

                    </ul>
                </div>
            </div>
        </div>
    </footer>
    <!-- end::Footer -->
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      appName: '',
      creatorUrl: '',
      creatorName: ''
    }
  },
  created: function () {
    this.appName = process.env.APP_NAME
    this.creatorUrl = process.env.APP_CREATOR_WEBSITE
    this.creatorName = process.env.APP_CREATOR
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/footer/Footer.vue